import { Link } from "react-router-dom";
import { caseStudies } from "../content";

export function WorkPage() {
  return (
    <main id="main-content" className="interior-world work-world">
      <section className="work-showcase-hero">
        <div className="work-showcase-copy">
          <p className="route-kicker" data-hero-support>Selected product work</p>
          <h1>
            <span data-hero-line><span>Systems built</span></span>
            <span data-hero-line><span>for real use.</span></span>
          </h1>
          <p data-hero-support>Explore a real product and the commerce, conversation, and handoff systems behind it.</p>
          <a className="world-button" href="#projects" data-hero-support>View the projects</a>
        </div>
        <div className="work-showcase-stage" aria-label="Marky presenting connected product work">
          <img src="/visuals/marky-work-exhibition.webp" alt="Marky surrounded by conversation, commerce, and handoff artifacts" width="1586" height="992" fetchPriority="high" data-route-object />
        </div>
      </section>

      <section className="work-credibility" aria-label="Portfolio standards">
        <p>Flagship product</p>
        <p>Working demonstrations</p>
        <p>Operational evidence</p>
      </section>

      <section className="work-exhibition" id="projects">
        <header data-reveal>
          <h2>Three views into one standard.</h2>
          <p>Each project proves a different layer: product, commercial action, and the handoff into real operations.</p>
        </header>
        <div className="work-exhibition-list">
          {caseStudies.map((study) => (
            <article className={`work-exhibit work-exhibit--${study.tone}`} key={study.slug}>
              <Link to={`/work/${study.slug}`}>
                <div className="work-exhibit-media" data-clip-reveal>
                  <img src={study.image} alt={study.imageAlt} loading="lazy" />
                </div>
                <div className="work-exhibit-copy" data-reveal>
                  <p>{study.kind}</p>
                  <h3>{study.shortTitle}</h3>
                  <span>{study.summary}</span>
                  <div className="work-exhibit-tags" aria-label="Project capabilities">
                    {study.tags.map((tag) => <small key={tag}>{tag}</small>)}
                  </div>
                  <strong>Open the project <i aria-hidden="true">↗</i></strong>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </section>

      <section className="work-proof-field">
        <div data-reveal>
          <h2>Strategy is visible in what survives contact with reality.</h2>
        </div>
        <div className="work-proof-steps" data-reveal>
          <span>Brand language becomes interaction.</span>
          <span>Interaction becomes a working system.</span>
          <span>The system remains understandable to people.</span>
        </div>
      </section>

      <section className="interior-close">
        <img src="/brand/marky-dark.svg" alt="" aria-hidden="true" />
        <h2>Bring us the part that needs to become real.</h2>
        <Link className="world-button" to="/contact">Tell us what feels heavy <span aria-hidden="true">↗</span></Link>
      </section>
    </main>
  );
}
